import React from "react"
export default props => (
    <div id={props.id} className={`panel ${props.className || ""}`} style={{backgroundColor:props.bgcolor || "transparent"}}>
        <div className="wrapper" style={props.style}>
            {props.children}
        </div>
    </div>
)